import React from 'react';
import Marquee from 'react-fast-marquee';
import '../styles/ImagesMarquee.css';
import ZoomImage from './ZoomImage';

interface ImageMarqueeProps {
  images: { image: string; link: string }[]; // Cada imagen tiene un enlace asociado
  speed?: number; // Velocidad del scroll
}

const ImageMarquee: React.FC<ImageMarqueeProps> = ({ images, speed = 20 }) => {
  return (
    <>
        {/* Duplicamos las imágenes para el efecto de scroll continuo */}
        <Marquee speed={speed} pauseOnHover={true} gradient={true} gradientColor={'white'} loop={0}>
        {[...images, ...images, ...images].map((item, index) => (
            <ZoomImage key={index} src={item.image} url={item.link} alt={`slide-${index}`} />
        ))}
        </Marquee>
    </>
  );
};

export default ImageMarquee;
